<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click.stop>
        <div class="bg-white popup">
          <div class="popup-header">
            <h2 class="title">Dato a pedir al usuario</h2>
            <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup()" />
          </div>
          <div class="popup-body">
            <div class="input-group">
              <label for="name">Texto del dato*</label>
              <input
                id="name"
                type="text"
                placeholder="Ingresa el texto del dato"
                required
                v-model="nombreCampo" />
            </div>
          </div>
          <div class="popup-footer">
            <button @click="closePopup()" class="secondary_button">Cancelar</button>
            <button @click="saveClicked()" class="main_button">Guardar</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineEmits, defineProps } from 'vue';
  
  const props = defineProps({
    campoPedir: Object,
  });
  
  const visible = ref(false);
  const fieldId = ref(0);
  const planId = ref(0);
  const nombreCampo = ref("");
  const order = ref(0);

  const emit = defineEmits(['campoPedirChanged', 'campoPedirErrorHappened', 'campoPedirClosed']);

  watch(() => props.campoPedir, (newVal) => {
    visible.value = !!newVal;
    if (newVal !== null) {
      nombreCampo.value = newVal.nombre_campo;
      fieldId.value = newVal.id_campo;
      planId.value = newVal.id_promocion;
      order.value = newVal.orden;    
    }
  });

  const closePopup = () => {
    visible.value = false;
    fieldId.value = 0;
    planId.value = 0;
    nombreCampo.value = "";
    order.value = 0;
    emit('campoPedirClosed');
  };

  const saveClicked = async () => {
    if (nombreCampo.value.trim() === "") {
      emit('campoPedirErrorHappened', 'Por favor, complete el nombre del dato a pedir.');
      return;
    }

    emit('campoPedirChanged', {
        "estado": "ACTIVO",
        "id_campo": fieldId.value,
        "id_promocion": planId.value,
        "nombre_campo": nombreCampo.value,
        "orden": order.value
    });
    closePopup();
  }

  </script>
  
<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  /* .fixed is global */
  
  .bg-white {
    background-color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 100%;
    max-width: 500px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .popup-header {
    padding: var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--light-gray);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-color-dark);
    margin: 0;
  }

  .close_icon {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity var(--transition-fast);
  }

  .close_icon:hover {
    opacity: 1;
  }

  .popup-body {
    padding: var(--spacing-lg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  label {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-color-dark);
  }

  input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid var(--gray);
    border-radius: var(--radius-md);
    font-family: inherit;
    font-size: 14px;
    transition: border-color var(--transition-fast);
  }

  input:focus {
    outline: none;
    border-color: var(--primary-color);
  }

  .popup-footer {
    padding: var(--spacing-md) var(--spacing-lg);
    border-top: 1px solid var(--light-gray);
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-md);
    background-color: var(--white);
  }

  .secondary_button, .main_button {
    width: auto;
    min-width: 100px;
  }
  </style>
  